/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        ;(function () {

          	'use strict';

          	var isMobile = {
          		Android: function() {
          			return navigator.userAgent.match(/Android/i);
          		},
          			BlackBerry: function() {
          			return navigator.userAgent.match(/BlackBerry/i);
          		},
          			iOS: function() {
          			return navigator.userAgent.match(/iPhone|iPad|iPod/i);
          		},
          			Opera: function() {
          			return navigator.userAgent.match(/Opera Mini/i);
          		},
          			Windows: function() {
          			return navigator.userAgent.match(/IEMobile/i);
          		},
          			any: function() {
          			return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
          		}
          	};



          	var parallax = function() {
          		if ( !isMobile.any()) {
          			$(window).stellar();
          		}
          	};

          	var mobileMenuOutsideClick = function() {

          		$(document).click(function (e) {
          	    var container = $("#mo1-offcanvas, .js-mo1-nav-toggle");
          	    if (!container.is(e.target) && container.has(e.target).length === 0) {
          	    	if ( $('body').hasClass('offcanvas') ) {
              			$('body').removeClass('offcanvas');
              			$('.js-mo1-nav-toggle').removeClass('active');
          	    	}
          	    }
          		});

          	};



          	var header = function() {
          		$(window).scroll(function(){
          			var st = $(window).scrollTop();
          			if (st > 50) {
          				$('.home .mo1-nav').addClass('scrolled');
                  $('body').addClass('page-scrolled');
          			} else {
          				$('.home .mo1-nav').removeClass('scrolled');
                  $('body').removeClass('page-scrolled');
          			}
          		});

          	};

          	var navigation = function() {

          		$('body').on('click', '#mo1-offcanvas ul a:not([class="external"]), .main-nav a:not([class="external"])', function(event){
          			var section = $(this).data('nav-section');
          				if ( $('[data-section="' + section + '"]').length ) {
          			    	$('html, body').animate({
          			        	scrollTop: $('[data-section="' + section + '"]').offset().top - 55
          			    	}, 500, 'easeInOutExpo');
          			   }

          			   if ($('body').hasClass('offcanvas')) {
          			   	$('body').removeClass('offcanvas');
          			   	$('.js-mo1-nav-toggle').removeClass('active');
          			   }
          		   event.preventDefault();
          		   return false;
          		});

          	};


          	var offcanvasMenu = function() {

          		$('body').prepend('<div id="mo1-offcanvas" />');
          		$('body').prepend('<a href="#" class="js-mo1-nav-toggle mo1-nav-toggle"><i></i></a>');
          		var clone1 = $('.menu-1 > ul').clone();
          		$('#mo1-offcanvas').append(clone1);
          		var clone2 = $('.menu-2 > ul').clone();
          		$('#mo1-offcanvas').append(clone2);

          		$('#mo1-offcanvas .has-dropdown').addClass('offcanvas-has-dropdown');
          		$('#mo1-offcanvas')
          			.find('li')
          			.removeClass('has-dropdown');

          		// Hover dropdown menu on mobile
          		$('.offcanvas-has-dropdown').mouseenter(function(){
          			var $this = $(this);

          			$this
          				.addClass('active')
          				.find('ul')
          				.slideDown(500, 'easeOutExpo');
          		}).mouseleave(function(){

          			var $this = $(this);
          			$this
          				.removeClass('active')
          				.find('ul')
          				.slideUp(500, 'easeOutExpo');
          		});


          		$(window).resize(function(){

          			if ( $('body').hasClass('offcanvas') ) {

              			$('body').removeClass('offcanvas');
              			$('.js-mo1-nav-toggle').removeClass('active');

          	    	}
          		});
          	};


          	// Reflect scrolling in navigation
          	var navActive = function(section) {

          		var $el = $('.main-nav > ul');
          		$el.find('li').removeClass('active');
          		$el.each(function(){
          			$(this).find('a[data-nav-section="'+section+'"]').closest('li').addClass('active');
          		});

          	};

          	var navigationSection = function() {

          		var $section = $('section[data-section]');

          		$section.waypoint(function(direction) {

          		  	if (direction === 'down') {
          		    	navActive($(this.element).data('section'));
          		  	}
          		}, {
          	  		offset: '150px'
          		});

          		$section.waypoint(function(direction) {
          		  	if (direction === 'up') {
          		    	navActive($(this.element).data('section'));
          		  	}
          		}, {
          		  	offset: function() { return -$(this.element).height() + 155; }
          		});

          	};

          	var burgerMenu = function() {

          		$('body').on('click', '.js-mo1-nav-toggle', function(event){
          			var $this = $(this);


          			if ( $('body').hasClass('offcanvas') ) {
          				$('body').removeClass('offcanvas');
          			} else {
          				$('body').addClass('offcanvas');
          			}
          			$this.toggleClass('active');
          			event.preventDefault();

          		});
          	};



          	var contentWayPoint = function() {
              console.log('func contentWayPoint fired');
          		var i = 0;
          		$('.animate-box').waypoint( function( direction ) {

          			if( direction === 'down' && !$(this.element).hasClass('animated-fast') ) {

          				i++;
                  console.log(this.element);
          				$(this.element).addClass('item-animate');
          				setTimeout(function(){

          					$('body .animate-box.item-animate').each(function(k){
          						var el = $(this);
          						setTimeout( function () {
          							var effect = el.data('animate-effect');
          							if ( effect === 'fadeIn') {
          								el.addClass('fadeIn animated');
          							} else if ( effect === 'fadeInLeft') {
          								el.addClass('fadeInLeft animated');
          							} else if ( effect === 'fadeInRight') {
          								el.addClass('fadeInRight animated');
          							} else {
          								el.addClass('fadeInUp animated');
          							}

          							el.removeClass('item-animate');
          						},  k * 200, 'easeInOutExpo' );
          					});

          				}, 100);

          			}

          		} , { offset: '85%' } );
          	};


          	var dropdown = function() {

          		$('.has-dropdown').mouseenter(function(){

          			var $this = $(this);
          			$this
          				.find('.dropdown')
          				.css('display', 'block')
          				.addClass('animated-fast fadeInUpMenu');

          		}).mouseleave(function(){
          			var $this = $(this);

          			$this
          				.find('.dropdown')
          				.css('display', 'none')
          				.removeClass('animated-fast fadeInUpMenu');
          		});

          	};


          	var owlCarousel = function(){

          		var owl = $('.owl-carousel-carousel');
          		owl.owlCarousel({
          			items: 3,
          			loop: true,
          			margin: 20,
          			nav: true,
          			dots: true,
          			smartSpeed: 800,
          			navText: [
          		      "<i class='ti-arrow-left owl-direction'></i>",
          		      "<i class='ti-arrow-right owl-direction'></i>"
          	     	],
          	     	responsive:{
          	        0:{
          	            items:1
          	        },
          	        600:{
          	            items:2
          	        },
          	        1000:{
          	            items:3
          	        }
          	    	}
          		});


          		var owl = $('.owl-carousel-fullwidth');
          		owl.owlCarousel({
          			items: 1,
          			loop: true,
          			margin: 20,
          			nav: true,
          			dots: true,
          			smartSpeed: 800,
          			autoHeight: true,
          			navText: [
          		      "<i class='ti-arrow-left owl-direction'></i>",
          		      "<i class='ti-arrow-right owl-direction'></i>"
          	     	]
          		});

          	};


          	var goToTop = function() {

          		$('.js-gotop').on('click', function(event){

          			event.preventDefault();

          			$('html, body').animate({
          				scrollTop: $('html').offset().top
          			}, 500, 'easeInOutExpo');

          			return false;
          		});

          		$(window).scroll(function(){

          			var $win = $(window);
          			if ($win.scrollTop() > 200) {
          				$('.js-top').addClass('active');
          			} else {
          				$('.js-top').removeClass('active');
          			}

          		});

          	};


          	// Loading page
          	var loaderPage = function() {
          		$(".mo1-loader").fadeOut("slow");
          	};

            //MagnificPopup
            var MagnificPopup = function(){

                //video
                $('.video-link').magnificPopup({
                  type:'iframe',
                  iframe: {
                    markup: '<div class="mfp-iframe-scaler">'+
                              '<div class="mfp-close"></div>'+
                              '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
                            '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button

                    patterns: {
                      youtube: {
                        index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

                        id: 'v=', // String that splits URL in a two parts, second part should be %id%
                        // Or null - full URL will be returned
                        // Or a function that should return %id%, for example:
                        // id: function(url) { return 'parsed id'; }

                        src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
                      },
                      vimeo: {
                        index: 'vimeo.com/',
                        id: '/',
                        src: '//player.vimeo.com/video/%id%?autoplay=1'
                      },
                      gmaps: {
                        index: '//maps.google.',
                        src: '%id%&output=embed'
                      }

                      // you may add here more sources

                    },

                    srcAction: 'iframe_src', // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
                  }
                });

                $('.popup-link').magnificPopup({
                  type:'inline',
                  midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
                  callbacks: {
                    open: function() {
                      // Will fire when this exact popup is opened
                      // this - is Magnific Popup objec
                      setTimeout(function(){
                        var map = window.site_gmap;
                        google.maps.event.trigger(map, "resize");
                        center_map( map );
                      }, 500);
                    },
                    close: function() {
                      // Will fire when popup is closed
                    }
                    // e.t.c.
                  }
                });


            }


            var topbar = function(){
              $('.topbar .close').on('click', function(){
                $('.banner .topbar').hide();
                $('body').removeClass('topbar');
              });
            }

            var responsiveTabs = function(){
              $(document).on('show.bs.tab', '.nav-tabs-responsive [data-toggle="tab"]', function(e) {
                var $target = $(e.target);
                var $tabs = $target.closest('.nav-tabs-responsive');
                var $current = $target.closest('li');
                var $parent = $current.closest('li.dropdown');
            		$current = $parent.length > 0 ? $parent : $current;
                var $next = $current.next();
                var $prev = $current.prev();
                var updateDropdownMenu = function($el, position){
                  $el
                  	.find('.dropdown-menu')
                    .removeClass('pull-xs-left pull-xs-center pull-xs-right')
                  	.addClass( 'pull-xs-' + position );
                };

                $tabs.find('>li').removeClass('next prev');
                $prev.addClass('prev');
                $next.addClass('next');

                updateDropdownMenu( $prev, 'left' );
                updateDropdownMenu( $current, 'center' );
                updateDropdownMenu( $next, 'right' );
              });
              $($('.nav-tabs a')[1]).click();
              $($('.nav-tabs a')[0]).click();
            }







          	$(function(){
          		parallax();
          		mobileMenuOutsideClick();
          		header();
          		// navigation();
          		offcanvasMenu();
          		burgerMenu();
          		// navigationSection();
          		contentWayPoint();
          		dropdown();
              MagnificPopup();
          		goToTop();
          		loaderPage();
              topbar();
              responsiveTabs();
          	});


          }());
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
